import { render } from "./SEGFrameBuilder.vue?vue&type=template&id=c89189da&scoped=true&ts=true"
import script from "./SEGFrameBuilder.vue?vue&type=script&setup=true&lang=ts"
export * from "./SEGFrameBuilder.vue?vue&type=script&setup=true&lang=ts"

import "./SEGFrameBuilder.vue?vue&type=style&index=0&id=c89189da&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c89189da"],['__file',"resources/js/vue/domain/admin/seg-frame-builder/SEGFrameBuilder.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c89189da"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c89189da', __exports__)) {
    api.reload('c89189da', __exports__)
  }
  
  module.hot.accept("./SEGFrameBuilder.vue?vue&type=template&id=c89189da&scoped=true&ts=true", () => {
    api.rerender('c89189da', render)
  })

}


export default __exports__